import { useCallback, useMemo } from 'react';
import { useAppApi } from '@/lib/api';

export const errText = (ex, fallback) =>
  (ex.response && ex.response.data && ex.response.data.error) || ex.message || fallback;

/**
 * Every workspace tab talks to the same model through the same door: a custom action on
 * `/api/crud/GitApp` with `where:{id}`. Centralising that here keeps the tabs from each
 * re-deriving the envelope, and keeps `act` referentially stable so it can sit in a
 * `useEffect` dependency array without looping (see client/src/lib/api.js).
 */
export function useGitApp(id) {
  const { fetchApi } = useAppApi();

  const act = useCallback(
    async (action, data) => {
      const res = await fetchApi('gitAppAction', action, id, data);
      return res?.data ?? res;
    },
    [fetchApi, id],
  );

  return useMemo(() => ({ act, fetchApi }), [act, fetchApi]);
}
